// TODO fix imports(ui component should not be dependent on anything from outside ui)
// TODO there is already FileIcon.tsx in `feed/components`
// TODO: try to solve different imports in different files - 82948
import { type FileAsset, FileType, type FolderAsset, FolderType } from 'models/asset';
import { DefaultFileIcon, DocumentFileIcon, FolderIcon, ImgFileIcon, PdfFileIcon, SheetFileIcon } from '../icons';
import type { IconSize } from '../icons/icon-wrapper/withAntIconWrapper';

type P = {
  asset: FileAsset | FolderAsset;
  size?: IconSize;
};

const FileIconDeprecated = ({ asset, size = 'middle' }: P) => {
  if (asset.type === FolderType) {
    return <FolderIcon size={size} />;
  }

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  if (asset.type === FileType) {
    if (asset.contentType.includes('image')) {
      return <ImgFileIcon size={size} />;
    }

    if (asset.contentType.includes('pdf')) {
      return <PdfFileIcon size={size} />;
    }

    if (asset.contentType.includes('spreadsheetml')) {
      return <SheetFileIcon size={size} />;
    }

    if (['wordprocessingml', 'msword'].some((word) => asset.contentType.includes(word))) {
      return <DocumentFileIcon size={size} />;
    }
  }

  return <DefaultFileIcon size={size} />;
};

export default FileIconDeprecated;
